import React from 'react';
import Analytics from '@components/analytics';

const AnalyticsPage = () => {
  return <Analytics />;
};

export default AnalyticsPage;
